export default __webpack_public_path__ + "static/media/471.ff88eef6.png";